// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".podcasts__content-drop-links[data-v-9ab20304]{display:grid;grid-template-columns:repeat(3, 1fr);gap:16px;font-weight:400}@media screen and (max-width: 960px){.podcasts__content-drop-links[data-v-9ab20304]{grid-template-columns:1fr;gap:0}}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
